// DX-Comment - Added deltax_logo_with_text.svg image file to display the DeltaX branded logo instead of the default Metabase logo.
// DX-Comment- Replace favicon.ico and logo.svg files with DeltaX logo images
import DeltaxLogoWithText from "metabase/public/components/EmbedFrame/LogoBadge/deltax_logo_with_text.svg?component";

interface LogoIconProps {
  width?: number;
  height?: number;
  dark?: boolean;
  fill?: string;
}

export const DefaultLogoIcon = ({
  dark,
  height = 32,
  width,
  fill = "currentcolor",
}: LogoIconProps) => {
  return (
    // DX-Comment - Replaced the default Metabase SVG logo rendering with the DeltaX logo image component.
    <DeltaxLogoWithText
      width={width}
      height={height}
      fill={fill}
      aria-label="Deltax Logo"
      data-testid="main-logo-svg"
    />
  );
};

export function LogoIcon(props: LogoIconProps) {
  // DX-Comment - Updated logo component to use the DeltaX branded logo by default.
  return <DefaultLogoIcon {...props} />;
}